import { render } from "./AddDetail.vue?vue&type=template&id=5255ec45&scoped=true"
import script from "./AddDetail.vue?vue&type=script&lang=js"
export * from "./AddDetail.vue?vue&type=script&lang=js"

import "./AddDetail.vue?vue&type=style&index=0&id=5255ec45&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5255ec45"]])

export default __exports__